import { Component, Input, OnInit } from "@angular/core";
import {
  CustomColumnComponent,
  DataService,
  SharedModule,
} from "@bb-vendure/admin-ui/core";
import { GetProductFacetsDocument } from "src/generated-gql/graphql";
import { take, Observable } from "rxjs";

@Component({
  selector: "facets-column",
  imports: [SharedModule],
  templateUrl: "./product-facets-column.component.html",
  styleUrl: "./product-facets-column.component.scss",
  standalone: true,
})
export class ProductFacetsColumnComponent
  implements OnInit, CustomColumnComponent
{
  constructor(private dataService: DataService) {}

  valueListLength: number;

  facets$: Observable<any[]>;

  readonly initialLimit = 3;
  displayLimit: number;

  ngOnInit(): void {
    this.facets$ = this.dataService
      .query(GetProductFacetsDocument, {
        id: this.rowItem.id,
      })
      .mapSingle((res) => {
        this.valueListLength = res.product?.facetValues.length ?? 0;
        return res.product?.facetValues ?? [];
      });

    // this.dataService
    //   .query(GetProductFacetsDocument, {
    //     id: this.rowItem.id,
    //   })
    //   .single$.pipe(take(1))
    //   .subscribe((res) => {
    //     this.valueList = res.product?.facetValues ?? [];
    //   });
  }
  @Input() rowItem: { id: string };

  toggleDisplayLimit() {
    if (this.displayLimit === this.valueListLength) {
      this.displayLimit = this.initialLimit;
    } else {
      this.displayLimit = this.valueListLength;
    }
  }
}
